<template lang="pug">
  .table-responsive
    table#TBAutotanques.table.is-striped.is-fullwidth.is-narrow
      thead
        tr
          th.is-size-6
            | #
          th.is-size-6 
            | Autotanque
          th.is-size-6 
            | Capacidad
          th.is-size-6 
            | id_cre
          th.is-size-6 
            | Placa
          th.is-size-6
            | FechaMod
      tbody
        tr(v-for="(aut, index) in pg" :key="aut.id")
          td 
            a.button.is-text(@click="editarAutotanque(aut.id)") {{ index + 1 }}
          td {{ aut.pg }}
          td {{ aut.capacidad }}
          td {{ aut.id_cre }}
          td {{ aut.placas }}
          td {{ aut.FechaMod}}
</template>

<script>
  export default {
    name: 'TBAutotanques',
    props: {
      pg: {
        type: Array,
        default: []
      },
    },
    methods: {
      editarAutotanque(id) {
        console.log(id)
      }
    },
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/componentes/TbAutotanques.vue